import React, { useState, forwardRef, useImperativeHandle, useMemo, useEffect } from 'react';
import { Drawer, Button, Steps, Form, Input, Radio, notification, Space, Select, Alert } from 'antd';
import { RadiusUprightOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import TradingPartnersAPI from '../../../restAPI/TradingPartnersAPI';
import validationRules from '../../../assets/validation/rules';
import validateForm from '../../../utils/FormValidation';

const Context = React.createContext({
  name: 'Default',
});
const { Step } = Steps;
const { TextArea } = Input;
const onSearch = (value) => {
  console.log('search:', value);
};
const StepForm = forwardRef(({ onRefresh }, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { token } = useSelector(state => state.auth);
  const [countryCodes, setCountryCodes] = useState([]);
  const [iSGetCountryCodes, setISGetCountryCodes] = useState(true);
  const [stateCodes, setStateCodes] = useState([]);
  const [iSGetStateCodes, setISGetStateCodes] = useState(true);
  const [msicCodes, setMsicCodes] = useState([]);
  const [iSGetMsicCodes, setISGetMsicCodes] = useState(true);
  const [payload, setPayload] = useState({
    "_id": "",
    "tradingPartnerName": "",
    "tin": "",
    "registrationType": "",
    "registrationValue": "",
    "sst": "",
    "ttx": "",
    "msicCode": "",
    "msicDescription": "",
    "countryCode": "",
    "countryName": "",
    "status": 1,
    "email": "",
    "contactNumber": "",
    "addressLine1": "",
    "addressLine2": "",
    "addressLine3": "",
    "postalZone": "",
    "city": "",
    "stateName": "",
    "stateCode": "",
    "groupId": ""
  });
  const [errors, setErrors] = useState({});

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setPayload({ _id: ref.id });
      getTradingPartnerById(ref.id);
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
      if (onRefresh) onRefresh(); // Trigger refresh on close
    },
  }));

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

  const contextValue = useMemo(
    () => ({
      name: 'Ant Design',
    }),
    [],
  );

  const next = () => setCurrentStep(
    currentStep + 1,
    //getLhdnTinNumberValidation()
  );
  const prev = () => setCurrentStep(currentStep - 1);

  useEffect(() => {
    if (iSGetCountryCodes) {
      getCountryCodes();
      setISGetCountryCodes(false);
    }

    if (iSGetStateCodes) {
      getStateCodes();
      setISGetStateCodes(false);
    }

    if (iSGetMsicCodes) {
      getMsicCodes();
      setISGetMsicCodes(false);
    }
  },);

  const getTradingPartnerById = async (id) => {
    await TradingPartnersAPI.getTradingPartnerById(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), id).then((res) => {
      if (res?.data) {
        let status = 1;
        if (res.data.status) {
          status = 1;
        }
        else {
          status = 0;
        }
        setPayload({
          "_id": res.data._id,
          "tradingPartnerName": res.data.tradingPartnerName,
          "tin": res.data.tin,
          "registrationType": res.data.registrationType,
          "registrationValue": res.data.registrationValue,
          "sst": res.data.sst,
          "ttx": res.data.ttx,
          "msicCode": res.data.msicCode.code,
          "msicDescription": res.data.msicCode.description,
          "countryCode": res.data.country.code,
          "countryName": res.data.country.name,
          "status": status,
          "email": res.data.emailAddress,
          "contactNumber": res.data.contactNumber,
          "addressLine1": res.data.address.addressLine1,
          "addressLine2": res.data.address.addressLine2,
          "addressLine3": res.data.address.addressLine3,
          "postalZone": res.data.address.postalZone,
          "city": res.data.address.city,
          "stateName": (res.data.country.code !== "MYS") ? "Not Applicable" : res.data.address.state.name,
          "stateCode": (res.data.country.name !== "MYS") ? "17" : res.data.address.state.code,
          "groupId": res.data.groupId,
          "classificationCode": res.data.classificationCode,
          "companyCode": res.data.companyCode
        });
        if (res.data.country.code !== 'MYS') {
          setStateCodes([]);
        }
      }
    }).catch(err => {
      console.log("error getting trading partner data :", err.message);
    })
  };

  const getCountryCodes = async () => {
    //alert(companyId);
    await TradingPartnersAPI.getCountryCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        const rows = [];
        res.data.map((rowValue) => {
          rows.push({ value: rowValue.code, label: rowValue.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') })
        });
        setCountryCodes(rows);

      }
    }).catch(err => {
      console.log("error getting contry codes data :", err.message);
    })
  };

  const getStateCodes = async () => {
    await TradingPartnersAPI.getStateCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        const rows = [];
        res.data.map((rowValue) => {
          rows.push({ value: rowValue.code, label: rowValue.state })
        });
        setStateCodes(rows);
      }
    }).catch(err => {
      console.log("error getting state codes data :", err.message);
    })
  };

  const getMsicCodes = async () => {
    await TradingPartnersAPI.getMsciCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        const rows = [];
        res.data.sort((a, b) => a.code.localeCompare(b.code));
        res.data.map((rowValue) => {
          rows.push({
            value: rowValue.code,
            label: (
              <div
                style={{
                  whiteSpace: 'normal',
                  lineHeight: '1.5em',
                  maxWidth: '100%',
                  overflowWrap: 'break-word',
                }}
              >
                <strong>{rowValue.code}</strong> - {rowValue.description}
              </div>

            ),
            description: rowValue.description
          });
        });
        setMsicCodes(rows);
      }
    }).catch(err => {
      console.log("error getting msic codes data :", err.message);
    })
  };

  const getLhdnTinNumberValidation = async () => {
    await TradingPartnersAPI.getLhdnTinNumberValidation(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), payload.tin, payload.registrationType, payload.registrationValue).then((res) => {
      if (res) {
        openNotificationWithIcon('success', "Successful", `${res.message}`, 'bottomLeft');
      }
    }).catch(err => {
      openNotificationWithIcon('error', "TIN number validation failed", `${err.message}`, 'bottomLeft');
    })
  }

  const OnStateChange = (value) => {
    let state = stateCodes.filter(function (obj) {
      return obj.value === value
    });

    if (state.length > 0) {
      state.map((rowValue) => {
        setPayload({
          "_id": payload._id,
          "tradingPartnerName": payload.tradingPartnerName,
          "tin": payload.tin,
          "registrationType": payload.registrationType,
          "registrationValue": payload.registrationValue,
          "sst": payload.sst,
          "ttx": payload.ttx,
          "msicCode": payload.msicCode,
          "msicDescription": payload.msicDescription,
          "countryCode": payload.countryCode,
          "countryName": payload.countryName,
          "status": payload.status,
          "email": payload.email,
          "contactNumber": payload.contactNumber,
          "addressLine1": payload.addressLine1,
          "addressLine2": payload.addressLine2,
          "addressLine3": payload.addressLine3,
          "postalZone": payload.postalZone,
          "city": payload.city,
          "stateName": rowValue.label,
          "stateCode": rowValue.value,
          "groupId": localStorage.getItem('groupId')
        });
      });
    }
  }

  const OnCountryChange = (value) => {
    let contry = countryCodes.filter(function (obj) {
      return obj.value === value
    });

    if (contry.length > 0) {
      contry.map((rowValue) => {
        setPayload({
          "_id": payload._id,
          "tradingPartnerName": payload.tradingPartnerName,
          "tin": payload.tin,
          "registrationType": payload.registrationType,
          "registrationValue": payload.registrationValue,
          "sst": payload.sst,
          "ttx": payload.ttx,
          "msicCode": payload.msicCode,
          "msicDescription": payload.msicDescription,
          "countryCode": rowValue.value,
          "countryName": rowValue.label,
          "status": payload.status,
          "email": payload.email,
          "contactNumber": payload.contactNumber,
          "addressLine1": payload.addressLine1,
          "addressLine2": payload.addressLine2,
          "addressLine3": payload.addressLine3,
          "postalZone": payload.postalZone,
          "city": payload.city,
          "stateName": payload.stateName,
          "stateCode": payload.stateCode,
          "groupId": localStorage.getItem('groupId')
        });
      });
    }
  }

  const OnRegistrationTypeChange = (value) => {
    setPayload({
      "_id": payload._id,
      "tradingPartnerName": payload.tradingPartnerName,
      "tin": payload.tin,
      "registrationType": value,
      "registrationValue": payload.registrationValue,
      "sst": payload.sst,
      "ttx": payload.ttx,
      "msicCode": payload.msicCode,
      "msicDescription": payload.msicDescription,
      "countryCode": payload.countryCode,
      "countryName": payload.countryName,
      "status": payload.status,
      "email": payload.email,
      "contactNumber": payload.contactNumber,
      "addressLine1": payload.addressLine1,
      "addressLine2": payload.addressLine2,
      "addressLine3": payload.addressLine3,
      "postalZone": payload.postalZone,
      "city": payload.city,
      "stateName": payload.stateName,
      "stateCode": payload.stateCode,
      "groupId": localStorage.getItem('groupId')
    });
  }

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
      const err = validationResult.errors
      const newErrors = {};
      Object.keys(err).forEach((value) => {
        newErrors[value] = err[value];
      })
      setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
      const keyData = Object.keys(data)[0]
      setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
  }

  const onRadioChange = (e) => {
    setPayload({
      "_id": payload._id,
      "tradingPartnerName": payload.tradingPartnerName,
      "tin": payload.tin,
      "registrationType": payload.registrationType,
      "registrationValue": payload.registrationValue,
      "sst": payload.sst,
      "ttx": payload.ttx,
      "msicCode": payload.msicCode,
      "msicDescription": payload.msicDescription,
      "countryCode": payload.countryCode,
      "countryName": payload.countryName,
      "status": e.target.value,
      "email": payload.email,
      "contactNumber": payload.contactNumber,
      "addressLine1": payload.addressLine1,
      "addressLine2": payload.addressLine2,
      "addressLine3": payload.addressLine3,
      "postalZone": payload.postalZone,
      "city": payload.city,
      "stateName": payload.stateName,
      "stateCode": payload.stateCode,
      "groupId": localStorage.getItem('groupId')
    });
  };

  const OnMsicChange = (value) => {
    let msic = msicCodes.filter(function (obj) {
      return obj.value === value
    });

    if (msic.length > 0) {
      msic.map((rowValue) => {
        setPayload({
          "_id": payload._id,
          "tradingPartnerName": payload.tradingPartnerName,
          "tin": payload.tin,
          "registrationType": payload.registrationType,
          "registrationValue": payload.registrationValue,
          "sst": payload.sst,
          "ttx": payload.ttx,
          "msicCode": rowValue.label,
          "msicDescription": rowValue.value,
          "countryCode": payload.countryCode,
          "countryName": payload.countryName,
          "status": payload.status,
          "email": payload.email,
          "contactNumber": payload.contactNumber,
          "addressLine1": payload.addressLine1,
          "addressLine2": payload.addressLine2,
          "addressLine3": payload.addressLine3,
          "postalZone": payload.postalZone,
          "city": payload.city,
          "stateName": payload.stateName,
          "stateCode": payload.stateCode,
          "groupId": localStorage.getItem('groupId')
        });
      });
    }
  }

  const onSubmit = async () => {
    const formData = {
      "tradingPartnerName": payload.tradingPartnerName,
      "tin": payload.tin,
      "registrationType": payload.registrationType,
      "registrationValue": payload.registrationValue,
      "sst": payload.sst,
      "ttx": payload.ttx,
      "msicCode": {
        "code": payload.msicCode,
        "description": payload.msicDescription,
      },
      "country": {
        "code": payload.countryCode,
        "name": payload.countryName,
      },
      "status": payload.status,
      "emailAddress": payload.email,
      "contactNumber": payload.contactNumber,
      "address": {
        "addressLine1": payload.addressLine1,
        "addressLine2": payload.addressLine2,
        "addressLine3": payload.addressLine3,
        "postalZone": payload.postalZone,
        "city": payload.city,
        "state": {
          "name": payload.stateName,
          "code": payload.stateCode,
        }
      },
      "groupId": localStorage.getItem('groupId')
    };

    await TradingPartnersAPI.updateTradingPartner(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), formData)
      .then((response) => {
        onClose();
        openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'Trading partner update failed', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'Trading partner update failed', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const onClose = () => {
    setVisible(false);
    if (onRefresh) onRefresh(); // Trigger refresh on drawer close
    setPayload({
      "_id": "",
      "tradingPartnerName": "",
      "tin": "",
      "registrationType": "",
      "registrationValue": "",
      "sst": "",
      "ttx": "",
      "msicCode": "",
      "msicDescription": "",
      "countryCode": "",
      "countryName": "",
      "status": 1,
      "email": "",
      "contactNumber": "",
      "addressLine1": "",
      "addressLine2": "",
      "addressLine3": "",
      "postalZone": "",
      "city": "",
      "stateName": "",
      "stateCode": "",
      "groupId": ""
    });
    setErrors({});
    setCurrentStep(0);
  }

  // Content for each step
  const renderStepContent = () => {
    if (currentStep === 0) {
      return (
        <Form layout="vertical">
          {/* <Alert message="* Fields are required" type="warning" /> */}

          <Form.Item label="Trading Partner Name" validateStatus={errors.tradingPartnerName ? 'error' : ''} help={errors.tradingPartnerName || ''} required>
            <Input size="large" disabled name="tradingPartnerName" value={payload["tradingPartnerName"]} onChange={(e) => { setPayload(prev => ({ ...prev, tradingPartnerName: e.target.value })); const validateData = { tradingPartnerName: e.target.value }; validateFormData(validateData); }} placeholder="Trading Partner Name" />
          </Form.Item>

          <Form.Item label="Country" required>
            <Select
              showSearch
              disabled
              name='country'
              placeholder="Select country"
              value={payload["countryCode"]}
              optionFilterProp="label"
              onChange={OnCountryChange}
              size='large'
              options={countryCodes}
            />
          </Form.Item>
          <Form.Item label="Company Code"  >
            <Input size="large" name="company-code" placeholder="Company Code" disabled value={payload["companyCode"]} />
          </Form.Item>

          <Form.Item label="Classification Code"  >
            <Select
              size="large"
              defaultValue="Classification Code"
              disabled
              options={[{ value: 'Classification Code' }]}
              value={payload["classificationCode"] || "Select a Classification Code"}
            />
          </Form.Item>

          <Form.Item label="TIN" validateStatus={errors.tin ? 'error' : ''} help={errors.tin || ''} required>
            <Input size="large" disabled name="tin" value={payload["tin"]} onChange={(e) => { setPayload(prev => ({ ...prev, tin: e.target.value })); const validateData = { tin: e.target.value }; validateFormData(validateData); }} placeholder="TIN" />
          </Form.Item>

          <Form.Item label="SST" validateStatus={errors.sst ? 'error' : ''} help={errors.sst || ''} required>
            <Input size="large" disabled name="sst" value={payload["sst"]} onChange={(e) => { setPayload(prev => ({ ...prev, sst: e.target.value })); const validateData = { sst: e.target.value }; validateFormData(validateData); }} placeholder="SST" />
          </Form.Item>

          <Form.Item label="TTX" validateStatus={errors.ttx ? 'error' : ''} help={errors.ttx || ''} required>
            <Input size="large" disabled name="ttx" value={payload["ttx"]} onChange={(e) => { setPayload(prev => ({ ...prev, ttx: e.target.value })); const validateData = { ttx: e.target.value }; validateFormData(validateData); }} placeholder="TTX" />
          </Form.Item>

          <Form.Item label="Registration Type" required>
            <Select
              showSearch
              disabled
              name="registrationType"
              placeholder="Select Registration Type"
              optionFilterProp="label"
              value={payload["registrationType"]}
              onChange={OnRegistrationTypeChange}
              size='large'
              onSearch={onSearch}
              options={[
                {
                  value: 'NRIC',
                  label: 'NRIC',
                },
                {
                  value: 'Passport number',
                  label: 'Passport number',
                },
                {
                  value: 'Business registration number',
                  label: 'Business registration number',
                },
                {
                  value: 'Army number',
                  label: 'Army number',
                },
              ]} />
          </Form.Item>

          <Form.Item label="Registration Value" validateStatus={errors.registrationValue ? 'error' : ''} help={errors.registrationValue || ''} required>
            <Input size="large" disabled name="registrationValue" value={payload["registrationValue"]} onChange={(e) => { setPayload(prev => ({ ...prev, registrationValue: e.target.value })); const validateData = { registrationValue: e.target.value }; validateFormData(validateData); }} placeholder="Registration Value" />
          </Form.Item>

          <Form.Item label="MSIC Code" required>
            <Select
              showSearch
              disabled
              name="msicCode"
              placeholder="Select MSIC Code"
              optionFilterProp="label"
              value={payload["msicCode"]}
              onChange={OnMsicChange}
              size='large'
              options={msicCodes}
              optionRender={(option) => (
                <div
                  style={{
                    whiteSpace: 'normal',
                    lineHeight: '1.5em',
                    maxWidth: '100%',
                    overflowWrap: 'break-word',
                  }}
                >
                  {option.data.label}
                </div>
              )}
            />
          </Form.Item>

          <Form.Item label="Status" required>
            <Radio.Group name="status" disabled value={payload["status"]} onChange={onRadioChange}>
              <Radio value={1}>Active</Radio>
              <Radio value={0}>Inactive</Radio>
            </Radio.Group>
          </Form.Item>

        </Form>
      );
    } else if (currentStep === 1) {
      return <div> <Form layout="vertical">
        <Form.Item label="Email Address" validateStatus={errors.email ? 'error' : ''} help={errors.email || ''} required>
          <Input size="large" name="email" disabled value={payload["email"]} onChange={(e) => { setPayload(prev => ({ ...prev, email: e.target.value })); const validateData = { email: e.target.value }; validateFormData(validateData); }} placeholder="Email Address" />
        </Form.Item>

        <Form.Item label="Contact Number" validateStatus={errors.contactNumber ? 'error' : ''} help={errors.contactNumber || ''} required >
          <Input size="large" disabled name="contactNumber" value={payload["contactNumber"]} onChange={(e) => { setPayload(prev => ({ ...prev, contactNumber: e.target.value })); const validateData = { contactNumber: e.target.value }; validateFormData(validateData); }} placeholder="Contact Number" />
        </Form.Item>


        <Form.Item label="Address">
          <Form.Item label="Address Line 1" required>
            <Input size="large" disabled name="addressLine1" value={payload["addressLine1"]} onChange={(e) => { setPayload(prev => ({ ...prev, addressLine1: e.target.value })); }} placeholder="Address Line 1" />
          </Form.Item>

          <Form.Item label="Address Line 2">
            <Input size="large" disabled name="addressLine2" value={payload["addressLine2"]} onChange={(e) => { setPayload(prev => ({ ...prev, addressLine2: e.target.value })); }} placeholder="Address Line 2" />
          </Form.Item>

          <Form.Item label="Address Line 3">
            <Input size="large" disabled name="addressLine3" value={payload["addressLine3"]} onChange={(e) => { setPayload(prev => ({ ...prev, addressLine3: e.target.value })); }} placeholder="Address Line 3" />
          </Form.Item>

          <Form.Item label="Postal Zone">
            <Input size="large" disabled name="postalZone" value={payload["postalZone"]} onChange={(e) => { setPayload(prev => ({ ...prev, postalZone: e.target.value })); }} placeholder="Postal Zone" />
          </Form.Item>

          <Form.Item label="City Name" validateStatus={errors.city ? 'error' : ''} help={errors.city || ''} required >
            <Input size="large" disabled name="city" value={payload["city"]} onChange={(e) => { setPayload(prev => ({ ...prev, city: e.target.value })); const validateData = { city: e.target.value }; validateFormData(validateData); }} placeholder="City Name" />
          </Form.Item>

          <Form.Item label="State" required>
            <Select
              showSearch
              disabled
              name="state"
              placeholder="Select State"
              optionFilterProp="label"
              value={payload["stateName"]}
              onChange={OnStateChange}
              size='large'
              options={stateCodes}
            />
          </Form.Item>

        </Form.Item>
      </Form></div>;
    }
    return null;
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="View Trading Partner"
        width={700}
        visible={visible}
        onClose={() => onClose()}
        footer={
          <div style={{ textAlign: 'right' }}>
            {currentStep > 0 && (
              <Button style={{ marginRight: 8 }} size="large" onClick={prev}>
                Previous
              </Button>
            )}
            {currentStep < 1 ? (
              <Button type="primary" size="large" onClick={next}>
                Next
              </Button>
            ) : (
              <Button type="primary" hidden size="large" onClick={() => onSubmit()}>
                Submit
              </Button>
            )}
          </div>
        }
      >
        <Steps current={currentStep}>
          <Step title="General Information" />
          <Step title="Contact Information" />
        </Steps>
        <div style={{ marginTop: 24 }}>{renderStepContent()}</div>

      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
